
import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend, configure } from 'vee-validate';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

import {required, email} from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'This field is required'
});

extend('email', {
  ...email,
  message: 'E-mail address is not valid'
});
